import { ChevronRight, Home } from "lucide-react";
import Text from "./Text";
import { ROUTE_PATHS } from "../../../constants/routeConstants";

const PageHero = ({
  title,
  crumbs = [],
  eyebrow,
  description,
  align = "center",
}) => {
  const alignClass =
    align === "left"
      ? "items-start text-left"
      : "items-center text-center";

  const homeAlreadyInCrumbs = crumbs.some(
    (c) => c.href === ROUTE_PATHS.HOME || c.label?.toLowerCase() === "home",
  );

  return (
    <section 
      className={`relative w-full overflow-hidden bg-white py-16 md:py-24 bg-cover bg-center flex flex-col justify-center ${alignClass}`}
      style={{ backgroundImage: 'url("/hero-bg.png")' }}
    >
      {/* Content */}
      <div className={`relative max-w-[1440px] mx-auto px-6 lg:px-12 flex flex-col ${alignClass} gap-3 z-10`}>
        
        {/* Breadcrumbs */}
        <nav
          aria-label="Breadcrumb"
          className={`flex items-center flex-wrap gap-x-1.5 text-[11px] font-bold tracking-wider uppercase text-gray-400 ${align === "left" ? "justify-start" : "justify-center"}`}
        >
          {!homeAlreadyInCrumbs && (
            <>
              <Text is="a" href={ROUTE_PATHS.HOME} className="inline-flex items-center gap-1 hover:text-blue-600 transition-colors">
                Home
              </Text>
              <ChevronRight size={12} className="text-blue-500" />
            </>
          )}
          {crumbs.map((crumb, i) => {
            const isLast = i === crumbs.length - 1;
            return (
              <span key={i} className="inline-flex items-center gap-1.5">
                {crumb.href && !isLast ? (
                  <Text is="a" href={crumb.href} className="hover:text-blue-600 transition-colors">
                    {crumb.label}
                  </Text>
                ) : (
                  <span className={isLast ? "text-blue-600" : "text-gray-400"}>
                    {crumb.label}
                  </span>
                )}
                {!isLast && <ChevronRight size={12} className="text-blue-500" />}
              </span>
            );
          })}
        </nav>

        {/* Title */}
        <h1
          is="h3"
          className=" md:text-3xl lg:text-3xl font-extrabold text-[#001d66] tracking-tight leading-none"
        >
          {title}
        </h1>

        {/* Description */}
        {description && (
          <Text is="p" className="text-gray-500 max-w-lg mt-2 text-lg">
            {description}
          </Text>
        )}
      </div>
    </section>
  );
};

export default PageHero;